import { StepsBannerErrorConfigModel } from '../../../Common/Misc/models/banner-error-config.model';
import { DistributionStepsEnum } from '../components/Distribution/DistributionStepsNavigation/distribution-steps-navigation.component';

export enum DistributionBannerErrorTypeEnum {
    DISTRIBUTION_HEADER_ERROR = 'DistributionHeaderError',
    DISTRIBUTION_RECIPIENT_ERROR = 'DistributionRecipientError',
    DISTRIBUTION_FOOTER_MISSING_MERGE_TAGS_ERROR = 'DistributionFooterMissingMergeTagsError',
    DISTRIBUTION_FOOTER_COMPANY_ERROR = 'DistributionFooterCompanyError',
    DISTRIBUTION_FOOTER_CITY_ERROR = 'DistributionFooterCityError',
    DISTRIBUTION_FOOTER_STREETADDRESS_ERROR = 'DistributionFooterStreetAddressError',
    DISTRIBUTION_FOOTER_COUNTRY_ERROR = 'DistributionFooterCountryError',
    DISTRIBUTION_FOOTER_POSTALCODE_ERROR = 'DistributionFooterPostalCodeError',
    DISTRIBUTION_FOOTER_CONTACT_ERROR = 'DistributionFooterContactError',
    DISTRIBUTION_FOOTER_INVALID_EMAIL_ERROR = 'DistributionFooterInvalidEmailError'


}

export const bannerErrorsMap = new Map<string, StepsBannerErrorConfigModel>([
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_HEADER_ERROR,
        {errorId: 'header_errors', label: 'Discover.distribution.headerBlock', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_RECIPIENT_ERROR,
        {errorId: 'recipient_error',label: 'Discover.distribution.recipients', tab: DistributionStepsEnum.editRecipients}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_COMPANY_ERROR,
        {errorId: 'footerErrors_company',label: 'Discover.distribution.footer.settings.company', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_CITY_ERROR,
        {errorId: 'footerErrors_city',label: 'Discover.distribution.footer.settings.city', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_STREETADDRESS_ERROR,
        {errorId: 'footerErrors_streetAddress',label: 'Discover.distribution.footer.settings.streetAddress', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_COUNTRY_ERROR,
        {errorId: 'footerErrors_country',label: 'Discover.distribution.footer.settings.country', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_POSTALCODE_ERROR,
        {errorId: 'footerErrors_zip',label: 'Discover.distribution.footer.settings.postalCode', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_CONTACT_ERROR,
        {errorId: 'footerErrors_contact',label: 'Discover.distribution.footer.settings.contactInfo', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_MISSING_MERGE_TAGS_ERROR,
        {errorId: 'footerErrors_mergeTags',label: 'Discover.distribution.footer.settings.footerMergeTags', tab: DistributionStepsEnum.compose}],
    [DistributionBannerErrorTypeEnum.DISTRIBUTION_FOOTER_INVALID_EMAIL_ERROR,
        {errorId: 'footerErrors_email', label: 'Discover.distribution.footer.settings.email', tab: DistributionStepsEnum.compose}]
]);

